import React from "react";
import { Box, Typography, Button, Card } from "@mui/material";
import { useNavigate } from "react-router-dom";

function ExpireLink() {
  const navigate = useNavigate();

  return (
    <Box 
      sx={{ 
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
      }}
    >
      <Card
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '40px',
          borderRadius: '12px',
          maxWidth: '440px',
          width: '100%',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)'
        }}
      >
        <img 
          src={require("../assets/landing_page/Icons/Link expire.png")} 
          alt="Link Expired" 
          style={{ 
            width: '180px',
            marginBottom: '20px'
          }}
        />
        <Typography 
          variant="h5" 
          sx={{ 
            fontWeight: 600,
            marginBottom: '12px',
            fontFamily: 'Inter, sans-serif',
            fontSize: '18px',
            color: '#333'
          }}
        >
          Oops! It seems the link has expired
        </Typography>
        <Typography 
          sx={{ 
            color: '#666',
            marginBottom: '24px',
            fontFamily: 'Inter, sans-serif',
            fontSize: '14px'
          }}
        >
          Please contact the project owner regarding the link
        </Typography>
        <Button
          variant="contained"
          sx={{
            backgroundColor: 'red',
            '&:hover': {
              backgroundColor: '#e60000'
            },
            textTransform: 'none',
            fontFamily: 'Inter, sans-serif',
            padding: '6px 20px',
            borderRadius: '4px',
            fontSize: '14px'
          }}
          onClick={() => navigate('/home/myplans')}
        >
          Home Page
        </Button>
      </Card>
    </Box>
  );
}

export default ExpireLink;